module.exports = "/_next/static/images/logo-icon-1f7273d643d6db2cf0b7877fc7a75118.png";